import BaseClient from './baseClient';

class ProductWallClient extends BaseClient {
  async loadNextPage(
    params: RollupReqParams,
  ): Promise<{ products: WallItem[]; pages: RollupPages }> {
    let url = '';
    if (params.next) {
      url =
        '/proxy' +
        params.next +
        `&headerCallerId=${params.headerCallerId}&headerUserAgent=${params.headerUserAgent}`;
    } else {
      let queryParams = `searchTerms=${params.searchTerms}&count=${params.count}&consumerChannelId=${params.consumerChannelId}&anchor=${params.anchor}&filter=language(${params.language})&filter=marketplace(${params.marketplace})&headerCallerId=${params.headerCallerId}&headerUserAgent=${params.headerUserAgent}`;

      const searchOptions: string[] = [];
      for (const option of Object.entries(params.searchOptions)) {
        if (option[1]) {
          searchOptions.push(`${option[0]}:${option[1]}`);
        }
      }
      if (searchOptions.length > 0) {
        queryParams += `&searchOptions=${searchOptions.join(',')}`;
      }
      if (params.taxonomyIds && params.taxonomyIds?.[0]) {
        queryParams = queryParams.concat(
          `&filter=taxonomyIds(${params.taxonomyIds.join(',')})`,
        );
      }
      if (params.sort && params.sort !== '') {
        queryParams += `&sort=${params.sort}`;
      }
      if (params.previewDate) {
        queryParams += `&preview=true&previewDate=${params.previewDate}`;
      }
      url = `/proxy/product_feed/rollup_threads/v2?${queryParams}`;
    }

    const res: { objects: WallItem[]; pages: RollupPages } = await this.fetch(
      url,
    );
    if (!res.objects) {
      return {
        products: [],
        pages: {
          next: '',
          prev: '',
          totalPages: 0,
          totalResources: 0,
        },
      };
    }
    return {
      products: res.objects.filter(
        (item) => item.productInfo && item.productInfo.length > 0,
      ),
      pages: res.pages,
    };
  }
}

export default new ProductWallClient();
